var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SMSActivator',{attrs:{"fab":_vm.fab,"outlined":_vm.outlined,"tooltip":_vm.tooltip,"noDialog":_vm.noDialog,"color":_vm.color,"receiverItems":_vm.receiverItems,"sendSMSFunction":_vm.sendSMSFunction,"lang":_vm.lang}})
}
var staticRenderFns = []

export { render, staticRenderFns }